import mitt from 'mitt';

import type { OTPModalEvents } from '../OTPModal.types';

export const OTPModalEmitter = mitt<OTPModalEvents>();
